export default [
  {
    name: 'adminCP',
    label: 'labels.adminCPManagement',
    permissionKey: 'admin_c_p_management',
    children: [
      {
        name: 'vehicleCategoryManagement',
        label: 'labels.vehicleCategoryManagement',
        permissionKey: 'vehicle_category_management',
        children: [
          {
            name: 'vehicleCategoryAdd',
            label: 'labels.vehicleCategoryAdd',
            permissionKey: 'vehicle_category_add'
          },
          {
            name: 'vehicleCategoryEdit',
            label: 'labels.vehicleCategoryEdit',
            permissionKey: 'vehicle_category_edit'
          },
          {
            name: 'vehicleCategoryDelete',
            label: 'labels.vehicleCategoryDelete',
            permissionKey: 'vehicle_category_delete'
          },
          {
            name: 'vehicleCategoryArchive',
            label: 'labels.vehicleCategoryArchive',
            permissionKey: 'vehicle_category_archive'
          }
        ]
      },
      {
        name: 'businessManagement',
        label: 'labels.businessManagement',
        permissionKey: 'business_management',
        children: [
          {
            name: 'businessAdd',
            label: 'labels.businessAdd',
            permissionKey: 'business_add'
          },
          {
            name: 'businessEdit',
            label: 'labels.businessEdit',
            permissionKey: 'business_edit'
          },
          {
            name: 'businessDelete',
            label: 'labels.businessDelete',
            permissionKey: 'business_delete'
          },
          {
            name: 'businessArchive',
            label: 'labels.businessArchive',
            permissionKey: 'business_archive'
          }
        ]
      },
      {
        name: 'taskManagement',
        label: 'labels.taskManagement',
        permissionKey: 'task_management',
        children: [
          {
            name: 'taskAdd',
            label: 'labels.taskAdd',
            permissionKey: 'task_add'
          },
          {
            name: 'taskEdit',
            label: 'labels.taskEdit',
            permissionKey: 'task_edit'
          },
          {
            name: 'taskDelete',
            label: 'labels.taskDelete',
            permissionKey: 'task_delete'
          },
          {
            name: 'taskArchive',
            label: 'labels.taskArchive',
            permissionKey: 'task_archive'
          }
        ]
      },
      {
        name: 'nodeManagement',
        label: 'labels.nodeManagement',
        permissionKey: 'node_management',
        children: [
          {
            name: 'nodeAdd',
            label: 'labels.nodeAdd',
            permissionKey: 'node_add'
          },
          {
            name: 'nodeEdit',
            label: 'labels.nodeEdit',
            permissionKey: 'node_edit'
          },
          {
            name: 'nodeDelete',
            label: 'labels.nodeDelete',
            permissionKey: 'node_delete'
          },
          {
            name: 'nodeArchive',
            label: 'labels.nodeArchive',
            permissionKey: 'node_archive'
          }
        ]
      },
      {
        name: 'nodeLocationManagement',
        label: 'labels.nodeLocationManagement',
        permissionKey: 'node_location_management',
        children: [
          {
            name: 'nodeLocationAdd',
            label: 'labels.nodeLocationAdd',
            permissionKey: 'node_location_add'
          },
          {
            name: 'nodeLocationEdit',
            label: 'labels.nodeLocationEdit',
            permissionKey: 'node_location_edit'
          },
          {
            name: 'nodeLocationDelete',
            label: 'labels.nodeLocationDelete',
            permissionKey: 'node_location_delete'
          },
          {
            name: 'nodeLocationArchive',
            label: 'labels.nodeLocationArchive',
            permissionKey: 'node_location_archive'
          }
        ]
      },
      {
        name: 'nodeTypeManagement',
        label: 'labels.nodeTypeManagement',
        permissionKey: 'node_type_management',
        children: [
          {
            name: 'nodeTypeAdd',
            label: 'labels.nodeTypeAdd',
            permissionKey: 'node_type_add'
          },
          {
            name: 'nodeTypeEdit',
            label: 'labels.nodeTypeEdit',
            permissionKey: 'node_type_edit'
          },
          {
            name: 'nodeTypeDelete',
            label: 'labels.nodeTypeDelete',
            permissionKey: 'node_type_delete'
          },
          {
            name: 'nodeTypeArchive',
            label: 'labels.nodeTypeArchive',
            permissionKey: 'node_type_archive'
          }
        ]
      },
      {
        name: 'workflowManagement',
        label: 'labels.workflowManagement',
        permissionKey: 'workflow_management',
        children: [
          {
            name: 'workflowAdd',
            label: 'labels.workflowAdd',
            permissionKey: 'workflow_add'
          },
          {
            name: 'workflowEdit',
            label: 'labels.workflowEdit',
            permissionKey: 'workflow_edit'
          },
          {
            name: 'workflowDelete',
            label: 'labels.workflowDelete',
            permissionKey: 'workflow_delete'
          },
          {
            name: 'workflowArchive',
            label: 'labels.workflowArchive',
            permissionKey: 'workflow_archive'
          }
        ]
      }
    ]
  }
]
